import Splide from '@splidejs/splide';

const EL = '.js-hero';

if (document.querySelector(EL)) {
  const slider = new Splide(EL, {
    type: 'fade',
    arrows: false,
    pagination: true,
    breakpoints: {
      1024: {

      },
      767: {

      },
    },
  });

  slider.mount();
}
